export const DASHBOARD_COLORS = {
  red: '#D0021B',
  green: '#27ae60',
  amber: '#f59300',
  blue: '#2980b9',
  gray: '#d3d1c7',
  chartPalette: ['#D0021B', '#2980b9', '#27ae60', '#f59300', '#8e44ad', '#e67e22', '#7f8c8d'],
  bg: '#f4f4f2',
  border: 'rgba(0,0,0,0.08)',
  outletBars: ['#D0021B', '#e05c6a', '#ea8a93', '#f0adb4', '#f5cccf'],
  partnerBars: ['#f59300', '#f7a833', '#f9bc66', '#fbd099', '#fce4cc'],
}

/** Shared card chrome aligned with the dashboard reference mock. */
export const dashboardCardSx = {
  p: 2.5,
  border: '1px solid',
  borderColor: DASHBOARD_COLORS.border,
  borderRadius: '12px',
  bgcolor: '#fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.05)',
}

export const dashboardPillButtonSx = (active, compact = false) => ({
  minWidth: 0,
  px: compact ? 1.25 : 1.5,
  py: compact ? 0.25 : 0.625,
  fontSize: compact ? '11px' : '12px',
  fontWeight: 600,
  textTransform: 'none',
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
  borderRadius: '20px',
  border: '1px solid',
  borderColor: active ? DASHBOARD_COLORS.red : 'rgba(0,0,0,0.13)',
  bgcolor: active ? DASHBOARD_COLORS.red : '#fff',
  color: active ? '#fff' : '#555550',
  boxShadow: 'none',
  '&:hover': {
    bgcolor: active ? '#b00218' : DASHBOARD_COLORS.bg,
    borderColor: active ? DASHBOARD_COLORS.red : 'rgba(0,0,0,0.13)',
  },
})

export const formatCurrency = (value) => {
  const n = Number(value) || 0
  if (n >= 10000000) return `৳ ${(n / 10000000).toFixed(1)}Cr`
  if (n >= 100000) return `৳ ${(n / 100000).toFixed(1)}L`
  if (n >= 1000) return `৳ ${(n / 1000).toFixed(1)}K`
  return `৳ ${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`
}

export const formatNumber = (value) => {
  const n = Number(value) || 0
  return n.toLocaleString('en-IN')
}

export const formatTrend = (pct) => {
  const n = Number(pct) || 0
  if (n > 0) return { text: `+${n}%`, direction: 'up' }
  if (n < 0) return { text: `${n}%`, direction: 'down' }
  return { text: '0%', direction: 'neutral' }
}

/** Format 0–23 hour into compact 12-hour clock label (e.g. 14 → "2 PM"). */
export const formatHourLabel = (hour) => {
  const h = Number(hour)
  if (!Number.isFinite(h)) return ''
  const normalized = ((h % 24) + 24) % 24
  if (normalized === 0) return '12 AM'
  if (normalized === 12) return '12 PM'
  if (normalized < 12) return `${normalized} AM`
  return `${normalized - 12} PM`
}

/** Truncate long product names for chart axis labels. */
export const shortChartLabel = (label, maxLen = 14) => {
  const s = String(label || '')
  if (s.length <= maxLen) return s
  return `${s.slice(0, maxLen - 1)}…`
}
